import react, { Component } from "react";
import {
  DKLabel,
  DKButton,
  showToast,
  TOAST_TYPE,
  DKSpinner,
  INPUT_TYPE,
  DKCalendar,
  DKIcon,
  DKIcons,
  DKLine,
  DKInput,
  INPUT_VIEW_DIRECTION,
  Toggle,
} from "deskera-ui-library";
import RouteManager from "../../../../managers/RouteManager";
import { FEDERAL_FREQUENCY } from "../../ReportsConstants";
import { DATE_FORMAT } from "../../../../constants/Constant";
import ReportService from "../../../../services/ReportService";
import { saveAs } from "file-saver";
import {
  TENANT,
  TenantService,
} from "../../../../managers/TenantManagerService";
import moment from "moment";
import { getCPFYears } from "../../../../managers/common/CommonUtil";
import Utility from "../../../../utility/Utility";
import { withTranslation } from "react-i18next";
class Form941 extends Component {
  selectedYear = [0];
  selectedFedral = [0];
  requiredFormat = DATE_FORMAT.YYYYMMDD;
  federalFrequencyOptions = FEDERAL_FREQUENCY.map((res) => res.value);
  formType = "FORM941";
  constructor(props) {
    super(props);

    this.state = {
      year: getCPFYears(),
      canValidate: false,
      endDate: "",
      startDate: "",
      isDownloadInProgress: false,
    };
  }
  componentDidMount() {
    this.selectedYear = this.setDefaultCurrentYear();
    this.setQuarterAccountDetails(0, this.selectedYear);
    RouteManager.setPresenter(this);
  }
  export() {
    const { t } = this.props;
    this.setState({ ...this.state, isDownloadInProgress: true });
    let users = [];
    let fileName = `${TenantService.get(TENANT.FIRST_NAME)}_${TenantService.get(
      TENANT.LAST_NAME
    )} ${this.formType}.pdf`;

    if (this.selectedYear.length == 0 || this.selectedFedral.length == 0) {
      this.setState({
        ...this.state,
        canValidate: true,
      });
      return;
    }
    users.push(TenantService.get(TENANT.USER_ID));
    ReportService.apiConfig = {
      startDate: this.state.startDate,
      endDate: this.state.endDate,
    };
    ReportService.downloadForm(users, this.formType, {}).then(
      (response) => {
        if (response?.size) {
          saveAs(response, fileName);
        } else {
          showToast(t("NO_FORM_AVAILABLE"), TOAST_TYPE.FAILURE);
        }
        this.setState({ ...this.state, isDownloadInProgress: false });
      },
      (error) => {
        this.setState({ ...this.state, isDownloadInProgress: false });
        showToast("Internal Server Error", TOAST_TYPE.FAILURE);
      }
    );
  }
  setQuarterAccountDetails(month, selectedYear) {
    if (!Utility.isEmpty(month.toString()) && !Utility.isEmpty(selectedYear)) {
      let year = parseInt(this.state["year"][this.selectedYear[0]]);
      let fromDate = moment()
        .month(month)
        .year(year)
        .startOf("quarter")
        .format(this.requiredFormat);
      let toDate = moment()
        .month(month)
        .year(year)
        .endOf("quarter")
        .format(this.requiredFormat);
      this.setState({
        startDate: fromDate,
        endDate: toDate,
      });
    }
  }

  setDefaultCurrentYear() {
    const currentYear = moment().get("year").toString();
    const index = this.state["year"].findIndex((year) => year === currentYear);
    if (index != -1) {
      return [index];
    }
    return this.selectedYear;
  }

  render() {
    return (
      <div className="parent-width">
        <DKLabel text="Form 941" className="fw-m fs-l" />
        <div className="bg-white pb-l card-shadow mt-l">
          <DKLabel text="Form 941 for Employer's" className="fw-m fs-l p-l" />
          <DKLine className="bg-gray3  " />
          <div className="d-flex p-h-l">
            {
              <div className="" style={{ width: "35%" }}>
                <DKInput
                  title="Year"
                  value={this.selectedYear}
                  type={INPUT_TYPE.SELECT}
                  required={true}
                  canValidate={this.state.canValidate}
                  readOnly={false}
                  direction={INPUT_VIEW_DIRECTION.VERTICAL}
                  options={this.state.year}
                  errorMessage="Please select year"
                  onChange={(value) => {
                    this.selectedYear = value;
                    this.setQuarterAccountDetails(
                      FEDERAL_FREQUENCY[this.selectedFedral[0]].id,
                      this.selectedYear
                    );
                    this.setState({ canValidate: true });
                  }}
                />
              </div>
            }

            <div className="p-h-l" style={{ width: "35%" }}>
              <DKInput
                title="Quarter"
                value={this.selectedFedral}
                type={INPUT_TYPE.SELECT}
                required={true}
                canValidate={this.state.canValidate}
                readOnly={false}
                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                options={this.federalFrequencyOptions}
                errorMessage="Please select quarter"
                onChange={(value) => {
                  this.selectedFedral = value;
                  if (value.length != 0) {
                    this.setQuarterAccountDetails(
                      FEDERAL_FREQUENCY[value[0]].id,
                      this.selectedYear
                    );
                  } else {
                    this.setState({
                      ...this.state,
                      startDate: "",
                      endDate: "",
                      canValidate: true,
                    });
                  }
                }}
              />
            </div>

            <div
              className={`mb-xs ${this.isAdmin ? "mr-l" : ""}`}
              style={{ marginTop: "25px" }}
            >
              <div className="row">
                <div>
                  <DKButton
                    title="DOWNLOAD FORM"
                    icon={DKIcons.white.ic_download}
                    className={`bg-app text-white ${
                      this.isAdmin ? "ml-l" : ""
                    }`}
                    onClick={() => {
                      this.export();
                    }}
                    disabled={this.state.isDownloadInProgress}
                  />
                </div>
                {this.state.isDownloadInProgress && (
                  <div className="ml-s">
                    <DKSpinner />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Form941);
